import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useToggleAssetArchiveStatus } from 'src/Hooks/Mutations/useToggleAssetArchiveStatus';
import { useFetchAssetDetails } from 'src/Hooks/Queries/useFetchAssetDetails';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import styles from './ArchivedAssetWarning.module.scss';

const ArchivedAssetWarning = () => {
  const { t } = useTranslation();
  const { data: asset } = useFetchAssetDetails();
  const assetId = useCurrentAssetId();
  const { mutate, isLoading } = useToggleAssetArchiveStatus();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('main.archivedAsset.title', 'Bien archivé')}</div>
      <div className={styles.text}>
        {t(
          'main.archivedAsset.warning',
          'Ce bien est archivé, pour y avoir de nouveau accès vous devez le désarchiver.'
        )}
      </div>
      <Button
        onClick={() => mutate({ isArchived: false, assetId: assetId ?? '' })}
        loading={isLoading}
      >{`${t('main.archivedAsset.unarchive', 'Désarchiver')} ${asset?.name}`}</Button>
    </div>
  );
};

export default ArchivedAssetWarning;
